import { JSON } from '../utils/types'

export default class ZipCode {
  zipCode: string

  main: string

  additional: string

  locality: string

  city: string

  state: string

  unity: string

  ibge: string

  gia: string

  constructor(data: JSON = {}) {
    this.zipCode = data.zip_code
    this.main = data.main
    this.additional = data.additional
    this.locality = data.locality
    this.city = data.city
    this.state = data.state
    this.unity = data.unity
    this.ibge = data.ibge
    this.gia = data.gia
  }
}
